// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".illustration__title[data-v-563b6a5e] {\n  font-size: 1.5rem;\n  font-weight: bold;\n  text-align: center;\n  color: #5a5a5a;\n}\n.illustration__message[data-v-563b6a5e] {\n  text-align: center;\n  color: #a1a1a1;\n}\n.illustration-accent[data-v-563b6a5e] {\n  fill: var(--primary);\n}", ""]);
// Exports
module.exports = exports;
